import styled from 'styled-components';

export const InnerContentContainer = styled.div`
  margin-top: 1.5em;
  padding: 1em 1em 2em 1em;
  background-color: ${p => p.theme.colors.white};
  border-top: 1px solid ${p => p.theme.colors.greyDarkest};
  border-bottom: 1px solid ${p => p.theme.colors.greyDarkest};
`;
